var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M160,277.3c-53,0-96-43-96-96s43-96,96-96s96,43,96,96C255.9,234.3,213,277.3,160,277.3z M160,128 c-29.5,0-53.3,23.9-53.3,53.3c0,29.5,23.9,53.3,53.3,53.3s53.3-23.9,53.3-53.3C213.3,151.9,189.5,128,160,128z M320,490.7V480 c0-88.4-71.6-160-160-160S0,391.6,0,480v10.7C0,502.4,9.6,512,21.3,512s21.3-9.6,21.3-21.3V480c0-64.8,52.5-117.3,117.3-117.3 S277.3,415.2,277.3,480v10.7c0,11.8,9.6,21.3,21.3,21.3C310.4,512,320,502.4,320,490.7z M512,384c0-82.5-66.9-149.3-149.3-149.3 c-36.7,0-72.2,13.5-99.6,38c-8.9,7.8-9.7,21.3-1.9,30.1c7.8,8.9,21.3,9.7,30.1,1.9c0.1-0.1,0.2-0.2,0.3-0.3 c43.9-39.3,111.3-35.5,150.6,8.4c17.5,19.6,27.2,44.9,27.2,71.1c0,11.8,9.6,21.3,21.3,21.3C502.4,405.3,512,395.8,512,384z  M373.3,192c-53,0-96-43-96-96s43-96,96-96s96,43,96,96C469.3,149,426.3,191.9,373.3,192z M373.3,42.7C343.9,42.7,320,66.5,320,96 s23.9,53.3,53.3,53.3s53.3-23.9,53.3-53.3S402.8,42.7,373.3,42.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeam);
export default __webpack_public_path__ + "static/media/team.9192ff2114ea193453ea941dfffe9577.svg";
export { ForwardRef as ReactComponent };